import { MS_PER_SECOND } from '@marketplace-web/shared/utils'
import { clientSideMetrics } from '@marketplace-web/shared/client-metrics'

const GENERATE_LABEL_SCREEN_LOAD_COUNT_METRIC_NAME = 'generate_label_screen_load_count'
const GENERATE_LABEL_SCREEN_LOAD_DURATION_METRIC_NAME = 'generate_label_screen_load_duration'

export const incrementScreenLoadCounter = (state: 'succeeded' | 'failed' | 'initiated') => {
  clientSideMetrics.counter(GENERATE_LABEL_SCREEN_LOAD_COUNT_METRIC_NAME, { state }).increment()
}

export const observePageLoadTime = (state: 'succeeded' | 'failed', loadTime: number) => {
  clientSideMetrics
    .histogram(GENERATE_LABEL_SCREEN_LOAD_DURATION_METRIC_NAME, { state })
    .observe(loadTime / MS_PER_SECOND)
}
